<template>
  <component
    :is="multiline ? 'textarea' : 'input'"
    :id="id"
    :type="multiline ? undefined : type"
    :placeholder="placeholder"
    :value="modelValue"
    :rows="multiline ? rows : undefined"
    @input="onInput"
    :required="required"
    :disabled="isDisabled"
    :class="[
      'form-input',
      {
        'form-input-error': showError,
        'is-textarea': multiline,
        'is-disabled': isDisabled,
      },
    ]"
    v-bind="$attrs"
    :key="componentKey"
  />
</template>

<script setup lang="ts">
import { updateComponentKey } from '../../composables/ComponentKey'

const props = withDefaults(
  defineProps<{
    id: string
    modelValue: string
    multiline?: boolean
    type?: string
    placeholder?: string
    required?: boolean
    showError?: boolean
    rows?: number
    isDisabled?: boolean
  }>(),
  {
    multiline: false,
    isDisabled: false,
    type: 'text',
    rows: 4,
  }
)

const emit = defineEmits<{
  (e: 'update:model-value', value: string): void
}>()

function onInput(e: Event) {
  const el = e.target as HTMLInputElement | HTMLTextAreaElement
  emit('update:model-value', el.value)
}

let componentKey = updateComponentKey(props)
</script>

<style scoped>
.form-input {
  border: none;
  outline: none;
  box-shadow: none;
  color: var(--text-color);
  font: inherit;
  font-size: 14px;

  border-radius: 8px;
  border: 1px solid var(--border-color);

  padding: 12px;
  width: 100%;
  box-sizing: border-box;
}

.form-input::placeholder {
  color: var(--light-color);
  opacity: 1;
}

.is-textarea {
  min-height: 100px;
  resize: none;
  background: none;
}

.form-input-error {
  border: 1px solid #e32c57;
}

.is-disabled {
  background-color: #f5f6f8;
  color: #a0a4ad;
  cursor: not-allowed;
}
</style>
